var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleFooter',{attrs:{"menus":_vm.menuItems,"terms":_vm.termItems,"body-text":_vm._f("ScString")(_vm.fields.bodytext),"logo":_vm.logo}})
}
var staticRenderFns = []

export { render, staticRenderFns }